export * from './fetch'

export const TRN_PLAYERS_RESET = 'TRN_PLAYERS_RESET'

export const playersReset = () => ({
  payload: null,
  type: TRN_PLAYERS_RESET,
})
